import { createSelector } from 'reselect'
import { State } from '../../reducers/reducerType'

/**
 * Determines whether the Room has a valid state
 * @param state The Redux state
 */

const getBookingDocumentState = (state: State): boolean => state.docs.bookingDoc !== null
const getBridgeDataDocumentState = (state: State): boolean => state.docs.bridgeDataDoc !== null
const getUIDocumentState = (state: State): boolean => state.docs.uiDoc !== null

export default createSelector(
  [getBookingDocumentState, getBridgeDataDocumentState, getUIDocumentState],
  (hasBookingDocument, hasBridgeDataDocument, hasUIDocument) => {

    return hasBookingDocument && hasBridgeDataDocument && hasUIDocument

  })
